/** True when the active locale should use English static marketing documents. */
export function isEnglishLocale(language?: string): boolean {
  return !language || language.startsWith('en');
}
